module.exports = __webpack_public_path__ + "media/application/images/ui/icons-action-bar-9dfe9f079875f744508b824512521a89.png";